import { render } from "./EmailServiceSettingsBlock.vue?vue&type=template&id=1bc3223c"
import script from "./EmailServiceSettingsBlock.vue?vue&type=script&lang=js"
export * from "./EmailServiceSettingsBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__